import { useEffect, useState } from 'react';

import { Divider, Grid, Typography, useTheme } from '@mui/material';

import MainCard from 'src/components/MainCard/MainCard';
import { useAddMerchantContext } from 'src/contexts/AddMerchantProvider';
import { isApplicationEditable } from 'src/pages/MerchantApplicationPage/merchantApplicationHelpers.util';

const BeneficialOwnerSupportingDocuments = ({
    principal,
    index,
    isUploadingDocuments,
    idDocumentTypes,
    addressDocumentTypes,
    acceptedFilesToUpload,
    FileUploadDropDown,
}) => {
    const [title, setTitle] = useState<string>('');
    const theme = useTheme();
    const { merchantApplication } = useAddMerchantContext();
    const isEditingDisabled = isApplicationEditable(merchantApplication);
    const [isReadOnly, setIsReadOnly] = useState<boolean>(isEditingDisabled);

    useEffect(() => {
        const supportingDocumentsTitle = isUploadingDocuments
            ? `Beneficial Owner's Proof of ID & Proof of Address - ${principal.firstName} ${principal.lastName}`
            : `Principal ${index + 1} - ${principal.firstName} ${principal.lastName}`;

        setTitle(supportingDocumentsTitle);
    }, [isUploadingDocuments, principal, index]);

    useEffect(() => {
        setIsReadOnly(isEditingDisabled);
    }, [isEditingDisabled]);

    return (
        <MainCard>
            <Typography sx={{ fontSize: 24, mb: 1 }}>{title}</Typography>
            <Divider
                sx={{
                    borderColor: `${theme.palette.warning.main}`,
                    mb: 4,
                }}
            />
            <Grid container rowSpacing={2} columnSpacing={2} rowGap={2}>
                <Grid item xs={12} md={6}>
                    <FileUploadDropDown
                        name={`principalDocuments.${index}.idFile`}
                        fileTypes={idDocumentTypes.map(({ key, value }) => ({
                            value,
                            label: key,
                        }))}
                        acceptedFileTypes={acceptedFilesToUpload}
                        label="Upload Proof of ID"
                        placeholder="Upload Proof of ID"
                        isReadOnly={isReadOnly}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <FileUploadDropDown
                        name={`principalDocuments.${index}.addressFile`}
                        fileTypes={addressDocumentTypes.map(({ key, value }) => ({
                            value,
                            label: key,
                        }))}
                        acceptedFileTypes={acceptedFilesToUpload}
                        label="Proof of Address"
                        placeholder="Proof of Address"
                        isReadOnly={isReadOnly}
                    />
                </Grid>
            </Grid>
        </MainCard>
    );
};

export default BeneficialOwnerSupportingDocuments;
